import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ClientsService {
    saveCorrelationId(correlationId: string) {
        sessionStorage.setItem('CorrelationId', correlationId);
    }

    getCorrelationId(): string {
        return sessionStorage.getItem('CorrelationId');
    }

    removeClient() {
        sessionStorage.removeItem('CorrelationId');
    }
}
